import { autoSaveAnswers } from '@/api/studentVirtualSimulationService';
import { useState, useEffect, useRef } from 'react';

export const useAnswerManager = (
    simulationId: string | undefined,
    initialAnswers: Record<string, string>,
    status: string,
) => {
    const [answers, setAnswers] = useState(initialAnswers);
    const answersRef = useRef(answers);

    useEffect(() => {
        answersRef.current = answers;
    }, [answers]);

    useEffect(() => {
        setAnswers(initialAnswers);
    }, [initialAnswers]);

    useEffect(() => {
        if (status !== 'in_progress_s1' && status !== 'in_progress_s2') {
            return;
        }

        const handleAutoSave = async () => {
            if (!simulationId || Object.keys(answersRef.current).length === 0) return;
            try {
                await autoSaveAnswers(simulationId, answersRef.current);
                console.log("Respuestas auto-guardadas exitosamente.");
            } catch (err) {
                console.error("Error en el auto-guardado:", err);
            }
        };

        const intervalId = setInterval(handleAutoSave, 300000);

        return () => clearInterval(intervalId);
    }, [status, simulationId]);

    const handleAnswerChange = (questionId: number, answer: string) => {
        setAnswers(prevAnswers => ({
            ...prevAnswers,
            [questionId]: answer,
        }));
    };

    return {
        answers,
        handleAnswerChange,
    };
};
